import React, { Component, Fragment } from 'react'
import style from './style.module.less'
import { observer, inject } from 'mobx-react'
import { Radio } from 'hljd'
import Input from '@components/Hotel/Common/Input'

@inject('store')
@observer
export default class extends Component {
  constructor(p) {
    super(p)
    this.state = {
      dishName: ''
    }
  }

  render() {
    const { store } = this.props
    const { serveType, servePercent, serveFee, setFromValue } = store

    return (
      <Fragment>
        <Radio.Group
          value={serveType}
          onChange={setFromValue('serveType')}
          defaultValue={3}
        >
          <Radio value={1}>面议</Radio>
          <Radio value={2}>固定比例</Radio>
          <Radio value={3}>固定金额</Radio>
          <Radio value={4}>无</Radio>
        </Radio.Group>
        {serveType === 2 && (
          <div className={style.input}>
            <span className={style.label}>按菜单价格加收</span>
            <Input
              style={{ width: 240 }}
              inputChange={setFromValue('servePercent')}
              value={servePercent}
            />{' '}
            % (精准到0.1%)
          </div>
        )}
        {serveType === 3 && (
          <div className={style.input}>
            <span className={style.label}>固定加收</span>
            <Input
              style={{ width: 240 }}
              inputChange={setFromValue('serveFee')}
              value={serveFee}
            />{' '}
            元/桌
          </div>
        )}
      </Fragment>
    )
  }
}
